// Admin wallet addresses (case-insensitive)
export const ADMIN_ADDRESSES: readonly `0x${string}`[] = [
  '0x6dc456595ae5fbc3eaa83880588d7786326478c2',
  '0x00a5eeca852d03c08f50fc8d75991b50dab953c9',
] as const;

export function isAdmin(address: string | undefined): boolean {
  if (!address) return false;
  const normalized = address.toLowerCase() as `0x${string}`;
  return ADMIN_ADDRESSES.some((admin) => admin.toLowerCase() === normalized);
}
